var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRetail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7015 1.47584L14.9972 7.1494C14.9446 7.57719 14.6076 7.89551 14.21 7.89551H5.5794C5.19843 7.89551 4.87148 7.60312 4.79874 7.19838L3.91436 2.23995H1.16112C0.680039 2.23995 0.291138 1.85033 0.291138 1.36998C0.291138 0.889616 0.680039 0.5 1.16112 0.5H14.9144C15.3954 0.5 15.7663 0.959474 15.7015 1.47584ZM8.06474 10.195C8.06474 9.47414 7.48068 8.89007 6.75978 8.89007C6.03888 8.89007 5.45481 9.47414 5.45481 10.195C5.45481 10.9159 6.03888 11.5 6.75978 11.5C7.48068 11.5 8.06474 10.9159 8.06474 10.195ZM14.4037 10.195C14.4037 9.47414 13.8197 8.89007 13.0988 8.89007C12.3779 8.89007 11.7938 9.47414 11.7938 10.195C11.7938 10.9159 12.3779 11.5 13.0988 11.5C13.8197 11.5 14.4037 10.9159 14.4037 10.195Z",
    fill: "#00AABE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRetail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_retail.7f1dec35665b6ea0fa09318e72da9bc5.svg";